import $ from 'jquery';

import ScrollbarWidth from './modules/scrollbar';
import Webinars from './modules/webinars';
import Projects from './modules/projects';
import Slick from './modules/slick';
import Maps from './modules/maps';
import Custom from './modules/custom';

$(() => {
  ScrollbarWidth();
  Webinars();
  Projects();
  Slick();
  Maps();
  Custom();
});
